const dashboard = {
  user_dash_title: 'Панель пользователя',
  user_dash_profile: 'Профиль',
  user_dash_favorites: 'Избранное',
  user_dash_consultations: 'Консультации',
  user_dash_compare: 'Сравнение',
  user_dash_recommendations: 'Рекомендации',
  user_dash_diary: 'Дневник лечения',
  user_dash_notifications: 'Уведомления',
  user_dash_contracts: 'Договоры',
  user_dash_password: 'Изменить пароль',
  user_dash_logout: 'Выйти',

  inst_dash_title: 'Панель учреждения',
  inst_dash_overview: 'Обзор',
  inst_dash_profile: 'Профиль учреждения',
  inst_dash_appointments: 'Управление записями',
  inst_dash_analytics: 'Аналитика',
  inst_dash_membership: 'Членство',
  inst_dash_contracts: 'Договоры',
  inst_dash_reconciliation: 'Сверка',
  inst_dash_notifications: 'Уведомления',
  inst_dash_logout: 'Выйти',

  admin_dash_title: 'Панель администратора',
  admin_dash_overview: 'Обзор',
  admin_dash_institutions: 'Управление учреждениями',
  admin_dash_users: 'Управление пользователями',
  admin_dash_consultations: 'Консультации',
  admin_dash_contracts: 'Управление договорами',
  admin_dash_packages: 'Управление пакетами',
  admin_dash_stats: 'Статистика',
  admin_dash_reports: 'Отчёты',
  admin_dash_settings: 'Настройки',
  admin_dash_logout: 'Выйти',

  user_dash_welcome: 'Добро пожаловать, {{name}}',
  user_dash_tab_profile: 'Профиль и уведомления',
  user_dash_tab_consultations: 'Мои запросы на консультацию',
  user_dash_tab_contracts: 'Мои договоры',
  user_dash_tab_password: 'Изменить пароль',
  user_dash_loading: 'Проверка сессии...',
  user_dash_remember_me: 'Запомнить меня',
  user_dash_back_to_login: 'Вернуться на страницу входа',
  user_dash_forgot_title: 'Забыли пароль',
  user_dash_forgot_desc: 'Введите зарегистрированный адрес эл. почты и мы отправим вам ссылку для сброса пароля.',
  user_dash_forgot_send: 'Отправить ссылку для сброса',
  user_dash_forgot_sending: 'Отправка...',
  user_dash_forgot_sent_title: 'Письмо отправлено!',
  user_dash_forgot_sent_desc: 'Ссылка для сброса пароля отправлена на <strong>{{email}}</strong>.',
  user_dash_forgot_spam: 'Если вы не нашли письмо, проверьте папку спама.',
  user_dash_back_to_login_btn: 'Вернуться к входу',
  user_dash_login_title: 'Вход для пользователей',
  user_dash_login_desc: 'Управляйте своим аккаунтом и просматривайте договоры',
  user_dash_fill_all: 'Пожалуйста, заполните все поля',
  user_dash_login_failed: 'Вход не выполнен',
  user_dash_no_account: 'Нет аккаунта?',
  user_dash_register: 'Зарегистрироваться',
  email_change_title: 'Изменение эл. почты',
  email_change_subtitle: 'Ваши данные для входа будут обновлены',
  email_change_desc: 'Вы меняете адрес эл. почты на <strong>{{email}}</strong>.',
  email_change_warning: 'После этого изменения вам нужно будет войти с <strong>новым адресом эл. почты</strong>.',
  email_change_confirm: 'Да, обновить',
  email_change_saving: 'Сохранение...',
  email_change_cancel: 'Отмена',
  profile_user_id: 'ID пользователя',
  profile_copy: 'Копировать',
  profile_copied: 'Скопировано!',
  profile_title: 'Информация профиля',
  profile_saved: 'Изменения сохранены.',
  profile_gender: 'Пол',
  profile_male: 'Мужской',
  profile_female: 'Женский',
  profile_other: 'Предпочитаю не указывать',
  profile_first_name: 'Имя',
  profile_last_name: 'Фамилия',
  profile_email: 'Эл. почта',
  profile_phone: 'Телефон',
  profile_country: 'Страна',
  profile_country_placeholder: 'Выберите страну',
  profile_city: 'Город',
  profile_city_placeholder: 'Выберите город',
  profile_city_select_country: 'Сначала выберите страну',
  profile_search_country: 'Поиск страны...',
  profile_search_phone: 'Поиск страны или кода...',
  profile_no_result: 'Результаты не найдены',
  profile_save_btn: 'Сохранить изменения',
  notif_title: 'Настройки уведомлений',
  notif_desc: 'Выберите, какие уведомления вы хотите получать',
  notif_saved: 'Настройки уведомлений сохранены.',
  notif_email_consult: 'Уведомление по эл. почте о запросе консультации',
  notif_email_consult_desc: 'Получать письмо при изменении статуса запроса',
  notif_email_newsletter: 'Письма рассылки',
  notif_email_newsletter_desc: 'Быть в курсе событий медицинского туризма',
  notif_sms_consult: 'SMS-уведомление',
  notif_sms_consult_desc: 'Получать SMS при одобрении запроса на консультацию',
  notif_sms_reminder: 'Напоминания',
  notif_sms_reminder_desc: 'Получать напоминание перед консультацией',
  notif_save_btn: 'Сохранить настройки',
  pwd_title: 'Изменить пароль',
  pwd_saved: 'Ваш пароль успешно изменён.',
  pwd_current: 'Текущий пароль',
  pwd_new: 'Новый пароль',
  pwd_new_placeholder: 'Не менее 6 символов',
  pwd_confirm: 'Подтвердите новый пароль',
  pwd_confirm_placeholder: 'Введите пароль ещё раз',
  pwd_mismatch: 'Пароли не совпадают',
  pwd_submit: 'Изменить пароль',
  pwd_verifying: 'Проверка...',
  pwd_strength_weak: 'Слабый',
  pwd_strength_medium: 'Средний',
  pwd_strength_strong: 'Сильный',
  pwd_err_current: 'Введите текущий пароль',
  pwd_err_min: 'Новый пароль должен содержать не менее 6 символов',
  pwd_err_mismatch: 'Новые пароли не совпадают',
  pwd_err_same: 'Новый пароль не может совпадать с текущим',
  pwd_err_unexpected: 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова.',
  consult_tab_loading: 'Загрузка...',
  consult_tab_empty: 'У вас ещё нет запросов на консультацию',
  consult_tab_explore: 'Исследовать учреждения',
  consult_tab_cancel: 'Отмена',
  consult_tab_cancel_confirm: 'Вы уверены, что хотите отменить этот запрос на консультацию?',
  consult_tab_cancelled: 'Запрос на консультацию отменён',
  consult_tab_cancel_failed: 'Отмена не удалась',
  consult_tab_evaluate: 'Оценить',
  consult_tab_view_inst: 'Просмотреть учреждение',
  consult_tab_appt_info: 'Информация о записи',
  consult_tab_appt_date: 'Дата',
  consult_tab_appt_note: 'Примечание',
  consult_tab_review_title: 'Написать отзыв',
  consult_tab_review_rating: 'Ваша оценка',
  consult_tab_review_comment: 'Ваш комментарий',
  consult_tab_review_comment_ph: 'Поделитесь своим опытом...',
  consult_tab_review_recommend: 'Я рекомендую это учреждение',
  consult_tab_review_submit: 'Отправить',
  consult_tab_review_cancel: 'Отмена',
  consult_tab_review_sent: 'Ваш отзыв отправлен и будет опубликован после одобрения',
  consult_tab_review_failed: 'Не удалось отправить отзыв',
  consult_tab_load_failed: 'Не удалось загрузить запросы на консультацию',
  consult_tab_status_waiting: 'Ожидание',
  consult_tab_status_appointed: 'Запись сделана',
  consult_tab_status_completed: 'Завершено',
  consult_tab_status_cancelled: 'Отменено',
  consult_tab_status_rejected: 'Отклонено',
  contracts_title: 'Мои договоры',
  contracts_desc: 'Вы можете просматривать одобренные вами договоры и их текущие версии.',
  contracts_loading: 'Загрузка...',
  contracts_empty: 'Договоры ещё не найдены',
  contracts_agreed_version: 'Версия, которую вы одобрили',
  contracts_outdated: 'Текущая версия: {{version}} доступна',
  contracts_up_to_date: 'Вы одобрили текущую версию',
  contracts_not_agreed: 'Вы ещё не одобрили этот договор',
  contracts_current_version: 'Текущая версия',
  contracts_effective_date: 'Дата вступления в силу',
  contracts_view_full: 'Просмотреть полное содержание',
  contracts_close: 'Закрыть',
  contracts_version_label: 'Версия',
  contracts_type_user_terms: 'Соглашение о членстве и использовании сайта',
  contracts_type_user_kvkk: 'Соглашение о согласии KVKK',
  contracts_type_user_marketing: 'Соглашение о маркетинговых коммуникациях',
  login_email: 'Эл. почта',
  login_password: 'Пароль',
  login_submit: 'Войти',
  login_logging_in: 'Вход...',
  login_error: 'Неверный адрес эл. почты или пароль.',
  login_forgot_password: 'Забыли пароль?',
  login_no_account: 'Нет аккаунта?',
  login_register: 'Зарегистрироваться',
  login_user_title: 'Вход для пользователей',
  login_institution_title: 'Вход для учреждений',
  login_admin_title: 'Вход администратора',
};

export default dashboard;
